import React from 'react';

interface CardProps {
  children: React.ReactNode;
  title?: string;
  subtitle?: string;
  className?: string;
  headerClassName?: string;
  bodyClassName?: string;
  footerClassName?: string;
  footer?: React.ReactNode;
  bordered?: boolean;
  elevated?: boolean;
  action?: React.ReactNode; // Add action prop for header actions like "Clear History"
}

export const Card: React.FC<CardProps> = ({
  children,
  title,
  subtitle,
  className = '',
  headerClassName = '',
  bodyClassName = '',
  footerClassName = '',
  footer,
  bordered = true,
  elevated = false,
  action,
}) => {
  // Glassmorphic UI styles
  const baseClasses = 'card rounded-xl overflow-hidden';
  const borderClasses = bordered ? '' : '';
  const elevationClasses = elevated ? 'shadow-xl shadow-[#001f59]/50 hover:shadow-[#001f59]/60 transition-all duration-300' : '';
  
  return (
    <div className={`${baseClasses} ${borderClasses} ${elevationClasses} ${className}`}>
      {(title || subtitle || action) && (
        <div className={`px-6 py-5 border-b border-gray-600/20 backdrop-blur-md ${headerClassName}`} style={{
          background: 'linear-gradient(to right, rgba(0, 31, 89, 0.6), transparent)'
        }}>
          <div className="flex justify-between items-start">
            <div>
              {title && <h3 className="text-xl font-bold text-white">{title}</h3>}
              {subtitle && <p className="text-sm text-gray-300 mt-1 opacity-80">{subtitle}</p>}
            </div>
            {action && <div className="ml-4">{action}</div>}
          </div>
        </div>
      )}
      
      <div className={`px-6 py-5 ${bodyClassName}`}>
        {children}
      </div>
      
      {footer && (
        <div className={`px-6 py-4 border-t border-gray-600/20 bg-gradient-to-b from-transparent to-gray-800/30 backdrop-blur-sm ${footerClassName}`}>
          {footer}
        </div>
      )}
    </div>
  );
};
